import {Checkbox as PepsicoDsCheckbox} from 'pepsico-ds'

/**
 * Checkbox component that renders a PepsicoDsCheckbox with provided properties.
 *
 * @param {Object} props - The properties object.
 * @param {boolean} props.value - The checked state of the checkbox.
 * @param {function} props.updateValue - The function to call when the checkbox value changes.
 * @param {string} props.label - The label text for the checkbox.
 * @param {Object} props.uiSchema - The UI schema object containing additional configuration.
 * @param {string} props.uiSchema.description - The helper text for the checkbox.
 * @param {boolean} props.uiSchema.readOnly - Indicates if the checkbox is read-only.
 * @param {boolean} [props.disabled=false] - Indicates if the checkbox is disabled.
 * @returns {JSX.Element} The rendered PepsicoDsCheckbox component.
 */
export default function Checkbox(props) {
  const {value, updateValue, label, uiSchema={}, disabled} = props
  return (
    <PepsicoDsCheckbox
      helperText={uiSchema.description}
      onUpdate={updateValue}
      text={label}
      checked={value}
      disabled={disabled || uiSchema.readOnly}
    />
  )
}
